import React, { Component } from "react";
import { Row } from "react-bootstrap";
import { Field, reduxForm } from "redux-form";

import ScrollToTopOnMount from "../../../../../utils/scroll/ScrollToTopOnMount";
import { formatDate } from "../../../../../utils/dates";

import Radio from "../../../../../components/common/radio/Radio";

import Ratings from "./Ratings";
import emptyStarIcon from "../../../../../assets/images/empty-star.svg";
import filledStarIcon from "../../../../../assets/images/filled-star.svg";

import styles from "./AdminProjectReview.scss";

class AdminProjectReview extends Component {
  constructor(props) {
    super(props);

    this.member_id = 0;
  }

  renderReview(review, reviewType) {
    const componentTypes = {
      radio: this.renderRadio,
      rating: this.renderRating,
      text: this.renderTextarea
    };

    let components =
      review.answers &&
      review.answers.map(answer => {
        answer.question.text = this.replaceWithName(
          answer.question.question,
          reviewType
        );
        return (
          componentTypes[answer.question.type.name] &&
          componentTypes[answer.question.type.name](answer, answer.value)
        );
      });

    components.push(
      review.contacts &&
        review.contacts.map(contact => {
          return this.renderContact(contact, reviewType);
        })
    );

    return components;
  }

  renderRating(answer, rating) {
    return (
      <Field
        name={answer.question.id.toString()}
        key={answer.question.id.toString()}
        component={Ratings}
        emptyIcon={emptyStarIcon}
        filledIcon={filledStarIcon}
        text={answer.question.text}
        props={{ rating: rating }}
      />
    );
  }

  renderTextarea(answer, comment) {
    return (
      <div key={answer.id + "_" + answer.question.id}>
        <p className={styles.question}>{answer.question.text}</p>
        <p className={styles.textarea}>
          {comment.split("\n").map(function(line, key) {
            return (
              <span key={answer.question.id + "_" + key}>
                {line}
                <br />
              </span>
            );
          })}
        </p>
      </div>
    );
  }

  renderRadio(answer, option) {
    return (
      <div key={answer.question.id.toString()}>
        <p className={styles.question}>{answer.question.text}</p>

        <div className={styles.radioGroupContainer}>
          <Field
            name={answer.question.id.toString()}
            component={Radio}
            type="radio"
            value={true}
            text="Yes"
            parse={val => val === "true"}
            disabled={true}
            props={{ selected: option == 1 }}
          />
          <Field
            name={answer.question.id.toString()}
            component={Radio}
            type="radio"
            value={false}
            text="No"
            parse={val => val === "true"}
            disabled={true}
            props={{ selected: option == 0 }}
          />
        </div>
      </div>
    );
  }

  renderContact(contact, reviewType) {
    return (
      <div key={contact.review_id.toString()}>
        <hr />
        <p className={styles.question}>
          {this.getReviewUserName(reviewType)} has referred a person that could
          use The Second Shift:
        </p>
        <div className={styles.contactInfo}>
          <b>{contact.name}</b> ({contact.email})
        </div>
      </div>
    );
  }

  replaceWithName(text, reviewType) {
    const replace = this.getReviewUserName(reviewType);

    return text ? text.replace("{{name}}", replace) : null;
  }

  getReviewUserName(reviewType) {
    let hired, name;

    switch (reviewType) {
      case "member":
        name = this.props.projectData.user.profile.company.name;
        break;

      case "employer":
        hired = this.props.projectData.hired.filter(hire => {
          if (hire.member_id == this.member_id) {
            return true;
          }
          return false;
        });

        if (hired.length > 0) {
          name = hired[0].member.first_name + " " + hired[0].member.last_name;
        }
        break;
    }

    return name;
  }

  render() {
    const { projectData } = this.props;

    // Look for the employer review
    const employerReview = _.filter(projectData.reviews, review => {
      if (review.source_id == projectData.user_id) {
        this.member_id = review.target_id;
        return true;
      }

      return false;
    });

    // Look for the member review
    const memberReview = _.filter(projectData.reviews, review => {
      if (review.target_id == projectData.user_id) {
        this.member_id = review.source_id;
        return true;
      }

      return false;
    });

    return (
      <div className={styles.reviewContainer}>
        <ScrollToTopOnMount />

        <div className={styles.projectReview}>
          <Row>
            <div className={styles.titleBlock}>
              <h1>Project Reviews</h1>
              <span className={styles.signedAndCreated}>
                Project completed on{" "}
                {formatDate(projectData.status_updated_at, "MMM D, Y h:mm A")}
              </span>
            </div>
            <div className={styles.subTitle} />
          </Row>

          <Row>
            <div className={styles.divider} />
            <div className={styles.divider} />
          </Row>

          <Row className={styles.sectionHeader}>
            <h2 className={styles.headerText}>Employer Review</h2>
          </Row>
          <Row>
            <div className={styles.whiteSection}>
              {employerReview.length > 0 ? (
                this.renderReview(employerReview[0], "employer")
              ) : (
                <p align="center">
                  Employer has not submitted the review yet or skipped it.
                </p>
              )}
            </div>
          </Row>

          <Row className={styles.sectionHeader}>
            <h2 className={styles.headerText}>Member Review</h2>
          </Row>
          <Row>
            <div className={styles.whiteSection}>
              {memberReview.length > 0 ? (
                this.renderReview(memberReview[0], "member")
              ) : (
                <p align="center">
                  Member has not submitted the review yet or skipped it.
                </p>
              )}
            </div>
          </Row>
        </div>
      </div>
    );
  }
}

export default reduxForm({
  form: "AdminProjectReview",
  initialValues: {}
})(AdminProjectReview);



// WEBPACK FOOTER //
// ./src/routes/admin/project/reviews/components/AdminProjectReview.js